<div class="error-box">
  <div class="error-body text-center" [ngSwitch]="DisplayCase">
    <ng-template [ngSwitchCase]="'403'">
      <h1 class="error-title text-danger">403</h1>
      <h3 class="text-uppercase error-subtitle">{{DisplayText}}</h3>
      <a routerLink="/Home" class="btn btn-danger btn-rounded waves-effect waves-light m-b-40">Back to home</a>
    </ng-template>
    <ng-template [ngSwitchCase]="'Maintenance'">
      <p class="error-title text-danger" style="font-size: 11vmin">Website Under Maintenance</p>
      <div style="padding: 0% 15%">
        <p style="font-size: 5vmin" class="error-subtitle">{{DisplayDuring}}</p>
        <p style="font-size: 4vmin;text-align:left" class="error-subtitle">{{DisplayText}}</p>
      </div>
    </ng-template>
  </div>
</div>